import { render, staticRenderFns } from "./GKPagination.vue?vue&type=template&id=310133e5&scoped=true&"
import script from "./GKPagination.vue?vue&type=script&lang=js&"
export * from "./GKPagination.vue?vue&type=script&lang=js&"
import style0 from "./GKPagination.vue?vue&type=style&index=0&id=310133e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310133e5",
  null
  
)

export default component.exports